/**
 * Api key control module
 */
import { requestData } from "./utils";
import CredentialsModule from "./credentials";
export default class ApiKeyModule {
  constructor() {
    this.credentials = new CredentialsModule();
  }
  getApiKeyLimit(api_key) {
    return requestData("GET", `/get_api_key_limits/${api_key}`);
  }
  add(api_key, enterprise_id, entity_id) {
    return requestData("POST", `/api_key`, {
      api_key: {
        ...api_key,
        enterprise_id,
        entity_id: entity_id ? entity_id : undefined,
      },
    });
  }
  getMaxMtMoConfig() {
    return requestData("GET", `/sms/smsConfig`);
  }
  get(api_key_id) {
    return requestData("GET", `/api_key/${api_key_id}`);
  }
  update(api_key_id, api_key) {
    return requestData("PUT", `/api_key/${api_key_id}`, { api_key });
  }
  updateAllowedSourceIps(api_key_id, values = {}) {
    return requestData("PUT", `/api_key/${api_key_id}`, {
      api_key: { allowed_source_ips: values.allowedIps, time_last_updated: values.time_last_updated },
    });
  }
  delete(api_key_id) {
    return requestData("DELETE", `/api_key/${api_key_id}`);
  }
  suspend(api_key_id, reason = null) {
    return requestData("POST", `/api_key_suspend/${api_key_id}`, { reason });
  }
  unsuspend(api_key_id) {
    return requestData("POST", `/api_key_unsuspend/${api_key_id}`);
  }
  retire(api_key_id, reason = null) {
    return requestData("POST", `/api_key_retire/${api_key_id}`, { reason });
  }
  activate(api_key_id) {
    //enterprise_id is used for getting the all of the users and then sending them the email
    return requestData("POST", `/api_key_activate/${api_key_id}`);
  }

  addNewSubAccount(parent_account_id, name) {
    return requestData("POST", `/create-sub-account/${parent_account_id}`, {
      name,
    });
  }

  setSubAccount(parent_account_id, api_key_id) {
    return requestData("POST", `/set-sub-account/${api_key_id}`, {
      parent_account_id,
    });
  }

  unsetSubAccount(api_key_id) {
    return requestData("PUT", `/unset-sub-account/${api_key_id}`);
  }

  getSubAccounts(query) {
    return requestData("GET", "/query/accounts", query);
  }

  convertToSMPP(api_key_id, data) {
    return requestData("POST", `/convert-to-smpp/${api_key_id}`, data);
  }

  convertToDummy(api_key_id){
    return requestData("POST", `/convert-to-dummy/${api_key_id}`);
  }

  setApiKeyAsDefault(account_id) {
    return requestData("POST", `/api-key-as-default/${account_id}`);
  }

  trial_limit = {
    get: (api_key_id) => {
      return requestData("GET", `/get_api_key_trial_limit/${api_key_id}`);
    },
    update: (data, api_key_id) => {
      return requestData("PUT", `/update_api_key_trial_limit/${api_key_id}`, data);
    },
    remove: (api_key_id) => {
      return requestData("DELETE", `/delete_api_key_trial_limit/${api_key_id}`);
    }
  }
}

